import { render, staticRenderFns } from "./SerieCard.vue?vue&type=template&id=92c92ec0&scoped=true&"
import script from "./SerieCard.vue?vue&type=script&lang=js&"
export * from "./SerieCard.vue?vue&type=script&lang=js&"
import style0 from "./SerieCard.vue?vue&type=style&index=0&id=92c92ec0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92c92ec0",
  null
  
)

export default component.exports